import { Component } from '@angular/core';

@Component({
  selector: 'app-bulk-vehicle-landing',
  templateUrl: './bulk-vehicle-landing.component.html',
  styleUrls: ['./bulk-vehicle-landing.component.scss']
})
export class BulkVehicleLandingComponent {

}
